var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"performance-wrapper"},[(_vm.preloader)?_c('preloader',{attrs:{"margin":"30px"}}):_c('PerformanceStats',{attrs:{"id":_vm.campaign.id,"type":"campaign","date-range":_vm.dateRange,"timezone":_vm.timezone}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }